import * as React from 'react';
import { colors } from '../../../index';

const IconCircleOne = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 21",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "#FCFCFC",
    opacity: 0.147,
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.556 14h-.907V7.986l-1.82.668v-.82l2.586-.97h.141z"
  })));
};

export default IconCircleOne;